import { render, staticRenderFns } from "./CustomCloudPricing.vue?vue&type=template&id=274245f7&scoped=true"
import script from "./CustomCloudPricing.vue?vue&type=script&lang=js"
export * from "./CustomCloudPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274245f7",
  null
  
)

export default component.exports